import { render, staticRenderFns } from "./EditProfileForm.vue?vue&type=template&id=64b0e1f2&scoped=true&"
import script from "./EditProfileForm.vue?vue&type=script&lang=js&"
export * from "./EditProfileForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b0e1f2",
  null
  
)

export default component.exports